export let AllAvatar = [];

for (let i = 0; i < 20; i++) {
  AllAvatar.push({
    id: i + 1,
    avt: `https://api.dicebear.com/9.x/adventurer-neutral/svg?seed=${i + 1}`,
  });
}
